import { setRefreshSearch } from '../data/refreshSearch/actions';

const StoreInsertion = (props, extraProps) => {
  if (extraProps && extraProps.refreshSearch) {
    props.dispatch(setRefreshSearch(true));
  }
};

export default StoreInsertion;
